<template lang="pug">
  .product-image
    .zoom(ref="zoom")
    .observer
      lazy-component(@show="show")
        img(:src="image.src")
    figure.image(
      :style="{ 'width': `${w}px`, 'height': `${h}px`, 'background-image': `url(${image.loading})` }"
      :class="{ loaded }"
      @click.prevent.default="openLightbox($event, 0)"
    )
      img(
        ref="image"
        title="Click to zoom in"
        :src="image.src"
        :class="{ loaded }"
      )
</template>

<script>
// import Drift from 'drift-zoom';

import PreviewImage from './PreviewImage';

export default {
    name: 'ProductImage',
    extends: PreviewImage,
    computed: {
        image() {
            let image = this.media.image;

            let root = '';
            const endpoint = `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}`;
            if (process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE) root = process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE;
            const base = endpoint + root + 'images/';

            let format = '';
            if (this.webpSupport) format = '&format=webp';

            let w = this.w;
            let h = this.h;
            if (window.devicePixelRatio) {
                w = Math.min(w * window.devicePixelRatio, image.width);
                h = Math.min(h * window.devicePixelRatio, image.height);
            }

            return {
                cdn: image.url,
                src: `${base}${image.id}/${image.name}?fit&w=${w}&h=${h}${format}`,
                srcFull: `${base}${image.id}/${image.name}`,
                error: `${base}${image.id}/${image.name}?fit&w=${w}&h=${h}&preview=greyscale`,
                blurry: `${base}${image.id}/${image.name}?fit&w=${w}&h=${h}&preview=blur`
            };
        }
    },
    methods: {
        openLightbox(event, i) {
            let photoswipeItem = {
                id: this.media.image.id,
                src: this.image.srcFull,
                w: this.media.image.width,
                h: this.media.image.height
            };
            this.$photoswipe.open(event, i, [photoswipeItem]);
        }
    },
    mounted() {
        // new Drift(this.$refs.image, {
        //     paneContainer: document.querySelector('.zoom-container'),
        //     inlinePane: false
        // });
    }
};
</script>

<style lang="sass" scoped>
.product-image
  display: flex
  justify-content: center
.observer
  display: absolute
  width: 0
  height: 0
  left: -300vw
.image
  @apply bg-gray-300 overflow-hidden
  background-position: center
  background-repeat: no-repeat
  background-size: cover
  width: 100%
  // &.loaded
  //   height: auto !important
  img
    opacity: 0
    width: 100%
    transition: opacity .3s ease
    cursor: pointer
    &.loaded
      opacity: 1
</style>
